import React, { Component, Suspense } from 'react';

import { Provider } from "react-redux";
import ConsultDeposit from './containers/ConsultDeposit';

import './assets/css/bootstrap.min.css';
import './assets/css/app.css';
import './assets/css/fonts.css';
import { gup } from "./utils/utils"

class App extends Component {
  constructor(props) {
    super(props)

    this.state = {
      isProtected: gup('id') && gup('name')
    }
  }

  render() {
    const { store } = this.props;
    return (
      <Provider store={store}>
        <Suspense fallback={(<div>Loading...</div>)}>
          <ConsultDeposit />
        </Suspense>
      </Provider>
    )
  }
}

export default App

